import { render, staticRenderFns } from "./CmgUpsell.vue?vue&type=template&id=d09dc1b8&scoped=true&lang=pug&"
import script from "./cmg-upsell.ts?vue&type=script&lang=ts&"
export * from "./cmg-upsell.ts?vue&type=script&lang=ts&"
import style0 from "./CmgUpsell.vue?vue&type=style&index=0&id=d09dc1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09dc1b8",
  null
  
)

export default component.exports